/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PaymentsAccountEligibilityService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getPaymentsAccountEligibility
 */
export const GET_PAYMENTS_ACCOUNT_ELIGIBILITY_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getPaymentsAccountEligibility';
export const GET_PAYMENTS_ACCOUNT_ELIGIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENTS_ACCOUNT_ELIGIBILITY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.getPaymentsAccountEligibilityRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getDefaultPaymentsAccountDetails
 */
export const GET_DEFAULT_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getDefaultPaymentsAccountDetails';
export const GET_DEFAULT_PAYMENTS_ACCOUNT_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.getDefaultPaymentsAccountDetailsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getPaymentsAccountDetails
 */
export const GET_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getPaymentsAccountDetails';
export const GET_PAYMENTS_ACCOUNT_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME,
  args: ['paymentsAccountId'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getPaymentsAccountDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getDefaultPublishableKey
 */
export const GET_DEFAULT_PUBLISHABLE_KEY_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getDefaultPublishableKey';
export const GET_DEFAULT_PUBLISHABLE_KEY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_PUBLISHABLE_KEY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.getDefaultPublishableKeyRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getDefaultActionEligibility
 */
export const GET_DEFAULT_ACTION_ELIGIBILITY_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getDefaultActionEligibility';
export const GET_DEFAULT_ACTION_ELIGIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_ACTION_ELIGIBILITY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    return chirpClient.call(References.getDefaultActionEligibilityRpc, {
      timeout: ctx.timeout
    });
  }
});